import { Release } from "@models/release";
import { Track } from "@models/track";
import { CollectionControls } from "../CollectionControls";
import {
	Container,
	Controls,
	PreText,
	Title,
	TitleContainer,
} from "./TitleControls.style";

interface Props {
	preText?: string;
	title?: React.ReactNode[] | React.ReactNode | JSX.Element | string;
	controlsPosition?: "left" | "right";
	tracks?: Track[];
	release?: Release;
	showPlay?: boolean;
	showAddToQueue?: boolean;
	showAddToPlaylist?: boolean;
	showAddToCart?: boolean;
	showSocial?: boolean;
	displayVertical?: boolean;
}

const TitleControls: React.FC<Props> = ({
	title,
	preText,
	controlsPosition = "left",
	showPlay,
	showAddToQueue,
	showAddToPlaylist,
	showAddToCart,
	showSocial,
	displayVertical = false,
	tracks = [],
	release,
}) => {
	const showControls = showPlay || showAddToQueue || showAddToPlaylist;
	return (
		<Container $displayVertical={displayVertical}>
			{controlsPosition === "left" && showControls && (
				<Controls data-testid="controls" className={preText ? "with-pre" : ""}>
					<CollectionControls
						showPlay={showPlay}
						showAddToQueue={showAddToQueue}
						showAddToPlaylist={showAddToPlaylist}
						showAddToCart={showAddToCart}
						showSocial={showSocial}
						tracks={tracks}
						release={release}
					/>
				</Controls>
			)}
			<TitleContainer>
				{preText && <PreText>{preText}</PreText>}
				{typeof title === "string" ? <Title>{title}</Title> : title}
			</TitleContainer>
			{controlsPosition === "right" && showControls && (
				<Controls data-testid="controls" className={preText ? "with-pre" : ""}>
					<CollectionControls
						showPlay={showPlay}
						showAddToQueue={showAddToQueue}
						showAddToPlaylist={showAddToPlaylist}
						showAddToCart={showAddToCart}
						showSocial={showSocial}
						tracks={tracks}
						release={release}
					/>
				</Controls>
			)}
		</Container>
	);
};

export default TitleControls;
